import { CustomAction } from '..';
import { Variant_Obj } from './product_list.reducers';

export interface Variant_Actions {
    undefined: Function;
    VARIANT_UPDATE: Function;
}

export const actions: Variant_Actions = {
    'undefined': (state = null, payload: any) => state,
    VARIANT_UPDATE: (state: Variant_Obj, payload: Variant_Obj) => payload
};

export function variantReducer (state: Variant_Obj, action: CustomAction): Variant_Obj | null {
    if (['VARIANT_UPDATE'].includes(action.type) && Object.keys(actions).includes(action.type)) return actions[action.type](state, action.payload);

    return state != undefined ? state : null;
}


// WEBPACK FOOTER //
// ./src/store/reducers/variant.reducer.ts